<template>
  <v-stepper-header style="box-shadow: none; max-width: 90vw;">
    <v-stepper-step
      step="1"
      :complete="step1Complete"
      editable
      edit-icon="mdi-check"
      :class="$vuetify.breakpoint.name === 'xs' ? 'align-start' : ''"
    >
      Intro*
    </v-stepper-step>

    <v-divider v-if="$vuetify.breakpoint.name !== 'xs'"></v-divider>

    <v-stepper-step
      step="2"
      :complete="step2Complete"
      editable
      edit-icon="mdi-check"
      :class="$vuetify.breakpoint.name === 'xs' ? 'align-start' : ''"
    >
      General*
    </v-stepper-step>

    <v-divider v-if="$vuetify.breakpoint.name !== 'xs'"></v-divider>

    <v-stepper-step
      step="3"
      :complete="step3Complete"
      editable
      edit-icon="mdi-check"
      :class="$vuetify.breakpoint.name === 'xs' ? 'align-start' : ''"
    >
      Corporate*
    </v-stepper-step>

    <v-divider v-if="$vuetify.breakpoint.name !== 'xs'"></v-divider>

    <v-stepper-step
      step="4"
      :complete="step4Complete"
      editable
      edit-icon="mdi-check"
      :class="$vuetify.breakpoint.name === 'xs' ? 'align-start' : ''"
    >
      Locations*
    </v-stepper-step>

    <v-divider v-if="$vuetify.breakpoint.name !== 'xs'"></v-divider>

    <v-stepper-step
      step="5"
      editable
      :edit-icon="step5Complete ? 'mdi-check' : 'mdi-minus'"
      :complete="step5Complete || currentStep > 5"
      :complete-icon="step5Complete ? 'mdi-check' : 'mdi-minus'"
      :class="$vuetify.breakpoint.name === 'xs' ? 'align-start' : ''"
    >
      Payroll
    </v-stepper-step>

    <v-divider v-if="$vuetify.breakpoint.name !== 'xs'"></v-divider>

    <v-stepper-step
      step="6"
      editable
      :edit-icon="step6Complete ? 'mdi-check' : 'mdi-minus'"
      :complete="step6Complete || currentStep > 6"
      :complete-icon="step6Complete ? 'mdi-check' : 'mdi-minus'"
      :class="$vuetify.breakpoint.name === 'xs' ? 'align-start' : ''"
    >
      Financial
    </v-stepper-step>

    <v-divider v-if="$vuetify.breakpoint.name !== 'xs'"></v-divider>

    <v-stepper-step
      step="7"
      editable
      :edit-icon="step6Complete ? 'mdi-check' : 'mdi-minus'"
      :complete="step7Complete || currentStep > 7"
      :class="$vuetify.breakpoint.name === 'xs' ? 'align-start' : ''"
    >
      Tax Prep
    </v-stepper-step>

    <v-divider v-if="$vuetify.breakpoint.name !== 'xs'"></v-divider>

    <v-stepper-step
      step="8"
      editable
      :class="$vuetify.breakpoint.name === 'xs' ? 'align-start' : ''"
    >
      Signature*
    </v-stepper-step>
  </v-stepper-header>
</template>

<script>
export default {
  name: 'StepHeader',
  data: () => ({
    temp: null,
  }),
  computed: {
    currentStep: {
      get() {
        return this.$store.state.stepper.currentStep;
      },
      set(value) {
        this.$store.commit('goToStep', value);
      },
    },
    benefitElection() {
      return this.$store.state.prospectPacket.flags.hasBenefitPacket;
    },
    step1Complete() {
      const { documents } = this.$store.state.prospectPacket;
      const workerCompDoc = documents.find((x) => x.category === 'WorkersCompensation');
      const workerCompPolicyInvoiceDoc = documents.find((x) => x.category === 'WorkersCompensationPolicyInvoice');
      const payrollRegisterDoc = documents.find((x) => x.category === 'PayrollRegister');
      const unemploymentDoc = documents.find((x) => x.category === 'UnemploymentReport');
      const workersCompLossDoc = documents.find((x) => x.category === 'WorkersCompLossReport');

      if (workerCompDoc
          || workerCompPolicyInvoiceDoc
          || payrollRegisterDoc
          || unemploymentDoc
          || workersCompLossDoc) {
        return true;
      }

      return false;
    },
    step2Complete() {
      const { legalName } = this.$store.state.prospectPacket.companyInfo;
      const { fedId } = this.$store.state.prospectPacket.companyInfo;

      if (legalName && fedId) {
        return true;
      }

      return false;
    },
    step3Complete() {
      const contactType = this.$store.state.prospectPacket.companyInfo.primaryContactType;
      const contact = this.$store.state.prospectPacket.contacts.find((x) => x.contactType === contactType);
      if (contact.name && contact.address1 && contact.state && contact.zip && contact.phone) {
        return true;
      }

      return false;
    },
    step4Complete() {
      const { employeeWorkStates } = this.$store.state.prospectPacket.companyInfo;
      const document = this.$store.state.prospectPacket.documents.find((x) => x.category === 'EmployeeStates');
      const locations = this.$store.state.prospectPacket.officeLocations.length;
      if (employeeWorkStates || document || locations > 0) {
        return true;
      }

      return false;
    },
    step5Complete() {
      const { employees } = this.$store.state.prospectPacket.payrollInformation;
      const { owners } = this.$store.state.prospectPacket.payrollInformation;
      if (employees.annualPayroll > 0
          || employees.fullTime > 0
          || employees.partTime > 0
          || employees.payrollFrequency
          || owners.fullTime > 0
          || owners.partTime > 0
          || owners.payrollFrequency) {
        return true;
      }

      return false;
    },
    step6Complete() {
      const { ssn } = this.$store.state.prospectPacket.companyInfo;
      const { ownerContactType } = this.$store.state.prospectPacket.companyInfo;
      const ownerContact = this.$store.state.prospectPacket.contacts.find((x) => x.contactType === ownerContactType);
      const bankContactType = this.$store.state.prospectPacket.bankInformation.contactType;
      const bankContact = this.$store.state.prospectPacket.contacts.find((x) => x.contactType === bankContactType);

      if (ownerContact.name
          || ownerContact.address1
          || this.$store.state.prospectPacket.companyInfo.ownerDOB
          || ownerContact.city
          || ownerContact.state
          || ownerContact.zip
          || this.$store.state.prospectPacket.companyInfo.date
          || ssn
          || this.$store.state.prospectPacket.bankInformation.bankName
          || bankContact.name
          || bankContact.phone
          || bankContact.email
          || this.$store.state.prospectPacket.bankInformation.accountNumber
          || this.$store.state.prospectPacket.flags.hasDelinquency
          || this.$store.state.prospectPacket.flags.hasCollections) {
        return true;
      }

      return false;
    },
    step7Complete() {
      const { firmName } = this.$store.state.prospectPacket.taxPreparer;
      const { contactType } = this.$store.state.prospectPacket.taxPreparer;
      const contact = this.$store.state.prospectPacket.contacts.find((x) => x.contactType === contactType);
      if (firmName
          || contact.name
          || contact.address1
          || contact.city
          || contact.state
          || contact.zip
          || contact.email
          || contact.phone) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style>
@media only screen and (max-width: 959.98px) {
  .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
    display: unset;
  }
  .v-stepper:not(.v-stepper--vertical) .v-stepper__step__step {
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
